"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { captureBrokerLeadAttributionFromUrl } from "@/lib/broker-lead-attribution";
import { markSellerFormReady } from "@/lib/seller-form-ready";
import { waitForIntakeControl } from "@/lib/wait-for-intake-control";

/** Valuation routes bypass the consultation portal that normally releases tracking. */
export function useValuationFormReady(owned: boolean): void {
  const pathname = usePathname();
  useEffect(() => {
    if (!owned) return;
    // Capture before releasing the pixel so its first ViewContent has this ad's attribution.
    captureBrokerLeadAttributionFromUrl();
    return waitForIntakeControl(markSellerFormReady, "[data-valuation-flow]");
  }, [owned, pathname]);
}
